var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserAlertcomponent = function SvgUserAlertcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6a2 2 0 1 1-3.999.001A2 2 0 0 1 8 6Zm-6 5c0-1.33 2.665-2 4-2s4 .67 4 2v1H2v-1Z",
    fill: "#CECCC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.334 2h-2.667v8h2.667V2Zm0 10.667a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0Z",
    fill: "#F49C20"
  })));
};
export default SvgUserAlertcomponent;